/**
 * 指定した機能キーの **いずれか** を持つユーザーにだけ子 (画面) を表示するルートガード
 * (マスタ変更履歴 SBI 7)。
 *
 * `RequireFeature` は機能キーを 1 つしか受け取れない。履歴画面は 6 つのマスタ画面の機能を
 * 横断するため、ルートは「いずれかを持つこと」で通し、マスタ種別ごとの判定は画面内で行う。
 * `RequireFeature` の挙動 (許可された先頭の画面へリダイレクト / 画面が無ければ
 * 「権限がありません」) はそのまま揃えてある。
 *
 * `featureKeys` が空のときは **誰も通さない** (キーの指定漏れで全員に開く事故を防ぐ)。
 *
 * ⚠️ 画面の出し分けは利便性のため。最終的な拒否は常にバックエンドの 403。
 */
import { Navigate } from 'react-router';

import { usePermissions } from '../contexts/PermissionContext';
import { landingPath } from '../permissions/screens';

import { NoPermissionScreen } from './NoPermissionScreen';

interface RequireAnyFeatureProps {
  featureKeys: readonly string[];
  children: React.ReactNode;
}

export function RequireAnyFeature({
  featureKeys,
  children,
}: RequireAnyFeatureProps): React.JSX.Element {
  const { features, has } = usePermissions();
  if (featureKeys.some((featureKey) => has(featureKey))) {
    return <>{children}</>;
  }
  const landing = landingPath(features);
  return landing ? <Navigate to={landing} replace /> : <NoPermissionScreen />;
}
